<template lang="pug">
    d2-container
      el-card(shadow="never")
        div(slot="header")
              font(style="font-weight: bold;font-size:16px; ") 参赛参训费用管理
        el-row(style="padding-bottom:15px;" :span="24")
            el-col(:md='23' :sm="5")
                el-button(@click='addOrUpdateHandle()'  type='primary' v-if="isAuth('pb:fee:add')" ) 添加
                el-button(@click='deleteClick(1)' :disabled='deleteClick1'  type='danger' v-if="isAuth('pb:fee:del')"  ) 删除
        el-table(:data="tableDataEnroll" style="width: 100%" v-loading='dataListLoading' border @selection-change='selectionChangeHandle1')
            el-table-column(type='selection', header-align='center', align='center', width='50')
            el-table-column(prop='title',header-align='center',align='center',label='名称')
            el-table-column(prop='remark',header-align='center',align='center',label='模板介绍')
            el-table-column(header-align='center',align='center',label='操作' width='100')
                    template(slot-scope="scope")
                      el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse" )
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1" @click="addOrUpdateHandle(scope.row.byx1,1)"  type="text"  v-if="isAuth('pb:fee:update')" ) 修改
                                el-menu-item(index="1-2" @click='deleteClick(1,scope.row)'  v-if="isAuth('pb:fee:del')" ) 删除
      el-card(shadow="never" style='margin-top:20px;')
        div(slot="header")
              font(style="font-weight: bold;font-size:16px;") 退费管理
        el-row(style="padding-bottom:15px;" :span="24")
            el-col(:md='23' :sm="5")
                el-button(@click='feeAddOrUpdateHandle()'  type='primary' v-if="isAuth('pb:fee:add')" ) 添加
                el-button(@click='deleteClick(2)' :disabled='deleteClick2'  type='danger'  v-if="isAuth('pb:fee:del')"  ) 删除
        el-table(:data="tableDataRefund" style="width: 100%" v-loading='dataListLoading' border @selection-change='selectionChangeHandle2')
            el-table-column(type='selection', header-align='center', align='center', width='50')
            el-table-column(prop='title',header-align='center',align='center',label='名称')
            el-table-column(prop='remark',header-align='center',align='center',label='模板介绍')
            el-table-column(header-align='center',align='center',label='操作' width='100')
                    template(slot-scope="scope")
                      el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse" )
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1" @click="feeAddOrUpdateHandle(scope.row.byx1,2)"  type="text" v-if="isAuth('pb:fee:update')"  ) 修改
                                el-menu-item(index="1-2" @click='deleteClick(2,scope.row)' v-if="isAuth('pb:fee:del')" ) 删除
        //- 培训添加和修改
        addOrUpdate(v-if='addOrUpdateVisible', ref="addOrUpdate",@refreshDataList='getDataList')
        //- 费用添加和修改
        feeAddOrUpdate(v-if='feeAddOrUpdateVisible', ref="feeAddOrUpdate",@refreshDataList='getDataList')
</template>

<script>
import AddOrUpdate from './train-add-or-update'
import feeAddOrUpdate from './fee-add-or-update'

export default {
  name: 'fee',
  data () {
    return {
      dialogFormVisible: false,
      isCollapse: true,
      loading: null,
      deleteClick1: true,
      deleteClick2: true,
      addOrUpdateVisible: false,
      feeAddOrUpdateVisible: false,
      elEnrollInfoVisible: false,
      selChangeData1: [],
      selChangeData2: [],
      dataListLoading: false,
      tableDataEnroll: [],
      tableDataRefund: []
    }
  },
  components: {
    AddOrUpdate,
    feeAddOrUpdate
  },
  mounted () {
    this.matchId = this.$route.query.matchId
    this.getDataList()
  },
  methods: {
    //操作三点
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },

    deleteClick (btn, row) {
      let byx1Arr = []
      if (btn === 1) {
        if (row) {
          byx1Arr.push(row.byx1)
        } else if (!this.selChangeData1 || this.selChangeData1.length === 0) {
          this.$message.error('请先勾选')
          return
        } else {
          this.selChangeData1.forEach(e => {
            byx1Arr.push(e.byx1)
          })
        }
      } else if (btn === 2) {
        if (row) {
          byx1Arr.push(row.byx1)
        } else if (!this.selChangeData2 || this.selChangeData2.length === 0) {
          this.$message.error('请先勾选要删除的模板')
          return
        } else {
          this.selChangeData2.forEach(e => {
            byx1Arr.push(e.byx1)
          })
        }
      }
      console.log('要删除的byx1', byx1Arr)
      this.$confirm('是否删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        console.log('确定=====')
          this.$http({
              url: this.$http.adornUrl(`/pbFeeTemplate/deleteByByx1`),
              method: 'post',
              data: byx1Arr.join(',')
          }).then((data) => {
              if (data && data.code === 0) {
                this.$message.success('操作成功!')
                this.getDataList()
              }
          })
      }).catch(() => {
          this.$message.info('已取消')
      })
    },
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    //培训添加或修改事件
    addOrUpdateHandle (byx1, flagType) {
      this.addOrUpdateVisible = true
      console.log('添加或修改参赛参训费用设置：', byx1)
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(byx1, flagType)
      })
    },
    // 费用添加修改
    feeAddOrUpdateHandle (byx1, flagType) {
      this.feeAddOrUpdateVisible = true
       this.$nextTick(() => {
        this.$refs.feeAddOrUpdate.init(byx1, flagType)
      })
    },
    getDataList () {
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/pbFeeTemplate/list'),
        method: 'post'
      }).then(data => {
        console.log('列表结果数据：', data)
        if (data && data.code === 0) {
          this.tableDataEnroll = data.enrollFeeList
          this.tableDataRefund = data.refundFeeList
        } else {
          this.tableDataEnroll = []
          this.tableDataRefund = []
        }
        this.dataListLoading = false
      })
    },
    //勾选列表事件
    selectionChangeHandle1 (val) {
      this.selChangeData1 = val
      if (this.selChangeData1 && this.selChangeData1.length > 0) {
        this.deleteClick1 = false
      } else {
        this.deleteClick1 = true
      }
    },
    selectionChangeHandle2 (val) {
      this.selChangeData2 = val
      if (this.selChangeData2 && this.selChangeData2.length > 0) {
        this.deleteClick2 = false
      } else {
        this.deleteClick2 = true
      }
    }
  }
}
</script>
<style >
/* 操作三点 菜单样式 */
@import "../../css/opr3dot.css";

.inputWidth {
  width: 200px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}

/* 提示框 */
.el-tooltip__popper.is-light {
  border: 1px solid #c0c4cc;
}

.el-tooltip__popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: grey !important ;
}

.toolTip > p {
  margin: 0;
  padding-top: 10px;
  height: 14px;
  line-height: 14px;
  font-size: 14px;
  color: #606266;
}

.el-dialog {
    position: relative;
    margin: 0 auto 80px;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 50%;
}
</style>
